import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
export default function Method(method) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      var baseOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              baseOptions = {
                dataType: 'json',
                xhrFields: {
                  withCredentials: true
                }
              };
              if (method.toLowerCase() === 'post') {
                Object.assign(this.request.options, baseOptions, {
                  type: 'post'
                });
              } else if (method.toLowerCase() === 'get') {
                Object.assign(this.request.options, baseOptions, {
                  type: 'get'
                });
              }
              _context.next = 4;
              return next();
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}